__turbopack_context__.v({
  "container": "marquee-module-scss-module__TKnSFa__container",
  "heading-container": "marquee-module-scss-module__TKnSFa__heading-container",
  "left-align": "marquee-module-scss-module__TKnSFa__left-align",
});
